export default __webpack_public_path__ + "static/media/teeth - inactive.ff84b1d3.ff84b1d3.svg";